import React from 'react'
import Api from '../../../../_helpers/Api'
import { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import NoDataFound from '../../../partials/NoDataFound'
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import ReservationOptions from '../../reservation/partials/Options'
import checkIcon from '../../../../assets/img/icons/check.png'
import Pagination from '../../../Pagination'
import { fromInfo, trans } from '../../../../_providers/Translation'
import Help from '../../../partials/Help'
import { contractorScopeConfig, contractorScopeType } from '../../../../_helpers/contractorScope'
import AllContractors from './AllContractors'

// styles
import "@/assets/scss/pages/contractors.scss"

// images
import tab1Image from "@/assets/img/contractors/icons/tab-1.svg"
import tab2Image from "@/assets/img/contractors/icons/tab-2.svg"
import tab3Image from "@/assets/img/contractors/icons/tab-3.svg"
import tab4Image from "@/assets/img/contractors/icons/tab-4.svg"
import tab5Image from "@/assets/img/contractors/icons/tab-5.svg"
import tab6Image from "@/assets/img/contractors/icons/tab-6.svg"
import alertImage from "@/assets/img/contractors/icons/alert.svg"

// libraries
import moment from 'moment'
import { Tooltip } from '@mui/material'

function Index(props) {

    const [state, setState] = useState({
        reservations: {
            loading: true,
            data: [],
            pages: 0,
            page: 1,
            update: false
        },
        contractors: {
            loading: true,
            data: [],
            pages: 0,
            page: 1,
            statuses: [],
            update: false
        },
        invoices: {
            loading: true,
            data: [],
            pages: 0,
            page: 1,
            update: false
        },
        reports: {
            loading: true,
            data: [],
            pages: 0,
            page: 1,
            update: false
        },
        unpaid: {
            loading: true,
            data: [],
            totals: null,
            currency: null
        },
        parts: {
            loading: true,
            data: [],
            pages: 0,
            page: 1,
            update: false
        },
    })

    const [activeTab, setActiveTab] = useState(0)

    // the dashboard is shared between the subscriptions and the warranties page
    const contractorsListHeading = contractorScopeType() === 'warranty'
        ? trans('random.contractorsWithWarrantiesList')
        : trans('random.contractorsWithSubscriptionsList')

    useEffect(() => {
        loadUnpaidInvoices()
    }, [])

    useEffect(() => {
        loadParts()
    }, [state.parts.update])

    useEffect(() => {
        loadReservations()
    }, [state.reservations.update])

    useEffect(() => {
        loadContractors()
    }, [state.contractors.update])

    useEffect(() => {
        loadSentInvoices()
    }, [state.invoices.update])

    useEffect(() => {
        loadSentReports()
    }, [state.reports.update])

    const loadParts = () => {
        setState(prev => ({
            ...prev,
            parts: {
                ...prev.parts,
                loading: true,
            }
        }))

        Api.get('contractors/all-parts-all-contractors?page=' + state.parts.page, contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    parts: {
                        ...prev.parts,
                        loading: false,
                        data: res.data.items,
                        pages: res.data.pages,
                    }
                }))
            })
    }

    const loadReservations = () => {
        setState(prev => ({
            ...prev,
            reservations: {
                ...prev.reservations,
                loading: true,
            }
        }))

        Api.get('contractors/reservations-with-changed-status?page=' + state.reservations.page, contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    reservations: {
                        ...prev.reservations,
                        loading: false,
                        data: res.data.items,
                        pages: res.data.pages,
                    }
                }))
            })
    }

    const loadContractors = () => {
        setState(prev => ({
            ...prev,
            contractors: {
                ...prev.contractors,
                loading: true,
            }
        }))

        Api.get('contractors/parts-statuses?page=' + state.contractors.page, contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    contractors: {
                        ...prev.contractors,
                        loading: false,
                        data: res.data.items,
                        statuses: res.data.statuses,
                        pages: res.data.pages,
                    }
                }))
            })
    }

    const loadSentInvoices = () => {
        setState(prev => ({
            ...prev,
            invoices: {
                ...prev.invoices,
                loading: true,
            }
        }))

        Api.get('contractors/mails?type=invoices&page=' + state.invoices.page, contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    invoices: {
                        ...prev.invoices,
                        loading: false,
                        data: res.data.items,
                        pages: res.data.pages,
                    }
                }))
            })
    }

    const loadSentReports = () => {
        setState(prev => ({
            ...prev,
            reports: {
                ...prev.reports,
                loading: true,
            }
        }))

        Api.get('contractors/mails?type=reports&page=' + state.reports.page, contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    reports: {
                        ...prev.reports,
                        loading: false,
                        data: res.data.items,
                        pages: res.data.pages,
                    }
                }))
            })
    }

    const loadUnpaidInvoices = () => {
        setState(prev => ({
            ...prev,
            unpaid: {
                ...prev.unpaid,
                loading: true,
            }
        }))

        Api.get('contractors/unpaid-invoices', contractorScopeConfig())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    unpaid: {
                        loading: false,
                        data: res.data.contractors,
                        totals: res.data.totals,
                        currency: res.data.currency
                    }
                }))
            })
    }

    const handlePage = page => {
        setState(prev => ({
            ...prev,
            contractors: {
                ...prev.contractors,
                page: page.selected + 1,
                update: new Date().getTime()
            }
        }))
    }

    const handlePartsPage = page => {
        setState(prev => ({
            ...prev,
            parts: {
                ...prev.parts,
                page: page.selected + 1,
                update: new Date().getTime()
            }
        }))
    }

    const handleReservationsPage = page => {
        setState(prev => ({
            ...prev,
            reservations: {
                ...prev.reservations,
                page: page.selected + 1,
                update: new Date().getTime()
            }
        }))
    }

    const handleInvoicesPage = page => {
        setState(prev => ({
            ...prev,
            invoices: {
                ...prev.invoices,
                page: page.selected + 1,
                update: new Date().getTime()
            }
        }))
    }

    const handleReportsPage = page => {
        setState(prev => ({
            ...prev,
            reports: {
                ...prev.reports,
                page: page.selected + 1,
                update: new Date().getTime()
            }
        }))
    }

    return (
        <div id="contractors-dashboard">
            <div className='pannel'>
                <ul className='custom-tabs'>
                    <li className={activeTab === 0 ? 'active' : ''} onClick={() => setActiveTab(0)}>
                        {trans('random.lastReservationsWithChangedStatus')}
                        <img src={tab1Image} alt="" />
                    </li>
                    <li className={activeTab === 1 ? 'active' : ''} onClick={() => setActiveTab(1)}>
                        {trans('headings.contractors')}
                        <img src={tab2Image} alt="" />
                    </li>
                    <li className={activeTab === 2 ? 'active' : ''} onClick={() => setActiveTab(2)}>
                        {trans('random.sentInvoices')}
                        <img src={tab3Image} alt="" />
                    </li>
                    <li className={activeTab === 3 ? 'active' : ''} onClick={() => setActiveTab(3)}>
                        {trans('random.sentReports')}
                        <img src={tab4Image} alt="" />
                    </li>
                    <li className={activeTab === 4 ? 'active' : ''} onClick={() => setActiveTab(4)}>
                        {trans('random.unpaidInvoices')}
                        <img src={tab5Image} alt="" />
                    </li>
                    <li className={activeTab === 5 ? 'active' : ''} onClick={() => setActiveTab(5)}>
                        {trans('random.partsUsedByCompanies')}
                        <img src={tab6Image} alt="" />
                    </li>
                </ul>

                {activeTab === 0 && (
                    <>
                        <h3>
                            {trans('tabs.list')} <Help>{fromInfo('contractors.latestReservations')}</Help>
                        </h3>
                        {state.reservations.loading
                            ?
                            <Skeleton height={45} count={10} />
                            :
                            state.reservations.data.length === 0
                                ?
                                <div className="alert warning">{trans('messages.noResultsFound')}</div>
                                :
                                <>
                                    <div className="table-scroller">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        ID
                                                    </th>
                                                    <th>
                                                        {trans('tables.refNo')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.contractor')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.address')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.status')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.lastStatus')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.employee')}
                                                    </th>
                                                    <th className="center">
                                                        {trans('tables.sentReport')}
                                                    </th>
                                                    <th className="options">
                                                        {trans('tables.options')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.reservations.data.map(r =>
                                                    <tr key={'r-' + r.id}>
                                                        <td>
                                                            {r.id}
                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={`/schedule/reservations/edit/${r.id}`}
                                                                // className="btn"
                                                                // style={{ background: r.color, color: r.text_color }}
                                                                data-tip
                                                                data-for={'tooltip-r-' + r.id}
                                                            >
                                                                {r.reference_code}
                                                            </Link>
                                                            <ReactTooltip
                                                                id={'tooltip-r-' + r.id}
                                                                effect="solid"
                                                            // backgroundColor={r.color}
                                                            // arrowColor={r.color}
                                                            // textColor={r.text_color}
                                                            >
                                                                {r.color_desc}
                                                            </ReactTooltip>
                                                        </td>
                                                        <td>
                                                            {r?.contractor?.deleted_at ? trans('random.deletedCompany') : r.contractor && r.contractor.name}
                                                        </td>
                                                        <td>
                                                            {r.full_address}
                                                        </td>
                                                        <td>
                                                            {r.finalstatus && r.finalstatus.translation && r.finalstatus.translation.name}
                                                        </td>
                                                        <td>
                                                            {r.prevfinalstatus && r.prevfinalstatus.translation && r.prevfinalstatus.translation.name}
                                                        </td>
                                                        <td>
                                                            {r.employee
                                                                ? `${r.employee.name} ${r.employee.lastname}`
                                                                : ''
                                                            }
                                                        </td>
                                                        <td className="center">
                                                            {r.send_reports
                                                                ?
                                                                <img src={checkIcon} alt="" />
                                                                :
                                                                ''
                                                            }
                                                        </td>
                                                        <td className="options">
                                                            <ReservationOptions
                                                                id={r.id}
                                                                data={r}
                                                                masterId={r.id}
                                                                handleRefresh={loadReservations}
                                                            />
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        pages={state.reservations.pages}
                                        page={state.reservations.page}
                                        handlePage={handleReservationsPage}
                                    />
                                </>
                        }
                    </>
                )}

                {activeTab === 1 && (
                    <>
                        {contractorScopeType() ?
                            <>
                                <h3>
                                    {contractorsListHeading} <Help>{fromInfo('contractors.parts')}</Help>
                                </h3>
                                {state.contractors.loading
                                    ?
                                    <Skeleton height={45} count={10} />
                                    :
                                    (state.contractors?.data || []).length === 0
                                        ?
                                        <div className="alert warning">{trans('messages.noResultsFound')}</div>
                                        :
                                        <>
                                            <div className="table-scroller">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '40px' }}>
                                                                ID
                                                            </th>
                                                            <th style={{ width: '20%' }}>
                                                                {trans('tables.name')}
                                                            </th>
                                                            {(state.contractors.statuses || []).map(s =>
                                                                <th key={'sth-' + s.id} className="center">
                                                                    {s.translation ? s.translation.name : s.name}
                                                                </th>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(state?.contractors?.data || []).map(r =>
                                                            <tr key={'r-' + r.id}>
                                                                <td style={{ width: '40px' }}>
                                                                    {r.id}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    <Link to={'/contractors/preview/' + r.id}>
                                                                        {r.name}
                                                                    </Link>
                                                                </td>
                                                                {(state?.contractors?.statuses || []).map(s =>
                                                                    <td key={'std-' + s.id} className="center">
                                                                        {r.statuses[s.id] > 0 ? r.statuses[s.id] : ''}
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                pages={state.contractors?.pages || 0}
                                                page={state.contractors?.page || 1}
                                                handlePage={handlePage}
                                            />

                                        </>
                                }

                                <hr />
                            </>
                            :
                            <>
                            </>
                        }
                        <AllContractors />
                    </>
                )}

                {activeTab === 2 && (
                    <>
                        <h3>
                            {trans('tabs.list')} <Help>{fromInfo('contractors.sentInvoices')}</Help>
                        </h3>
                        {state.invoices.loading
                            ?
                            <Skeleton height={45} count={10} />
                            :
                            state.invoices.data.length === 0
                                ?
                                <div className="alert warning">{trans('messages.noResultsFound')}</div>
                                :
                                <>
                                    <div className="table-scroller">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '20%' }}>
                                                        {trans('tables.name')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.to')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.topic')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.refNo')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.info')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.employee')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.date')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.invoices.data.map(r =>
                                                    <tr key={'si-' + r.id}>
                                                        <td>
                                                            <Link to={'/contractors/preview/' + r.contractor_id + '?tab=mails&type=invoices'}>
                                                                {r?.contractor?.deleted_at ? trans('random.deletedCompany') :
                                                                    r.contractor && r.contractor.name
                                                                }
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            {r.to}
                                                        </td>
                                                        <td>
                                                            {r.subject}
                                                        </td>
                                                        <td>
                                                            {r.reservation
                                                                ?
                                                                <a
                                                                    href={'/schedule/reservations/edit/' + r.reservation_id} target="_blank"
                                                                // className="btn"
                                                                // style={{ background: r.reservation.color, color: r.reservation.text_color }}
                                                                >
                                                                    {r.reservation.reference_code}
                                                                </a>
                                                                :
                                                                '-'
                                                            }
                                                        </td>
                                                        <td>
                                                            {r.url
                                                                ?
                                                                <a href={r.url} target="_blank">
                                                                    {trans('buttons.view')}
                                                                </a>
                                                                :
                                                                r.text
                                                            }
                                                        </td>
                                                        <td>
                                                            {r.employee
                                                                ?
                                                                `${r.employee.name} ${r.employee.lastname}`
                                                                :
                                                                '-'
                                                            }
                                                        </td>
                                                        <td>
                                                            {r.date}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        pages={state.invoices.pages}
                                        page={state.invoices.page}
                                        handlePage={handleInvoicesPage}
                                    />

                                </>
                        }
                    </>
                )}

                {activeTab === 3 && (
                    <>
                        <h3>
                            {trans('tabs.list')} <Help>{fromInfo('contractors.sentReports')}</Help>
                        </h3>
                        {state.reports.loading
                            ?
                            <Skeleton height={45} count={10} />
                            :
                            state.reports.data.length === 0
                                ?
                                <div className="alert warning">{trans('messages.noResultsFound')}</div>
                                :
                                <>
                                    <div className="table-scroller">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '20%' }}>
                                                        {trans('tables.name')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.to')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.topic')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.refNo')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.info')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.employee')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.date')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.reports.data.map(r =>
                                                    <tr key={'sr-' + r.id}>
                                                        <td>
                                                            <Link to={'/contractors/preview/' + r.contractor_id + '?tab=mails&type=reports'}>
                                                                {r?.contractor?.deleted_at ? trans('random.deletedCompany') :
                                                                    r.contractor && r.contractor.name}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            {r.to}
                                                        </td>
                                                        <td>
                                                            {r.subject}
                                                        </td>
                                                        <td>
                                                            {r.reservation
                                                                ?
                                                                <a
                                                                    href={'/schedule/reservations/edit/' + r.reservation_id} target="_blank"
                                                                // className="btn"
                                                                // style={{ background: r.reservation.color, color: r.reservation.text_color }}
                                                                >
                                                                    {r.reservation.reference_code}
                                                                </a>
                                                                :
                                                                '-'
                                                            }
                                                        </td>
                                                        <td>
                                                            {r.url
                                                                ?
                                                                <a href={r.url} target="_blank">
                                                                    {trans('buttons.view')}
                                                                </a>
                                                                :
                                                                r.text
                                                            }
                                                        </td>
                                                        <td>
                                                            {r.employee
                                                                ?
                                                                `${r.employee.name} ${r.employee.lastname}`
                                                                :
                                                                '-'
                                                            }
                                                        </td>
                                                        <td>
                                                            {r.date}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        pages={state.reports.pages}
                                        page={state.reports.page}
                                        handlePage={handleReportsPage}
                                    />

                                </>
                        }
                    </>
                )}

                {activeTab === 4 && (
                    <>
                        <h3>
                            {trans('tabs.list')} <Help>{fromInfo('contractors.unpaidInvoices')}</Help>
                        </h3>
                        {state.unpaid.loading
                            ?
                            <Skeleton height={45} count={10} />
                            :
                            state.unpaid.data.length === 0
                                ?
                                <div className="alert warning">{trans('messages.noResultsFound')}</div>
                                :
                                <>
                                    <div className="table-scroller">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {trans('tables.document')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.company')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.dueDate')}
                                                    </th>
                                                    <th className="right">
                                                        {trans('tables.netPrice')}
                                                    </th>
                                                    <th className="right">
                                                        {trans('tables.tax')}
                                                    </th>
                                                    <th className="right">
                                                        {trans('tables.gross')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.unpaid.data.map(c => {
                                                    const daysUntilDue = moment(c.due_date).diff(moment(), 'days')
                                                    const isOverdue = daysUntilDue <= 0
                                                    const isNear = daysUntilDue > 0 && daysUntilDue <= 20

                                                    return (
                                                        <tr key={'uc-' + c.id}>
                                                            <td>
                                                                <a href={c.link} target="_blank" rel="noopener noreferrer">
                                                                    {`#${c.invoice_num}`}
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <Link to={'/contractors/preview/' + c.id + '?tab=invoices&status=unpaid'}>
                                                                    {c.name}
                                                                </Link>
                                                            </td>
                                                            <td>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '5px'
                                                                    }}
                                                                >
                                                                    {isOverdue && <Tooltip title={trans('messages.overduePayment')}><img src={alertImage} alt="" /></Tooltip>}
                                                                    {moment(c.due_date).format('DD MMM YYYY')}
                                                                    {!isOverdue && <span style={isNear ? { color: '#EC5252' } : {}}>{trans('random.daysCount', { count: daysUntilDue })}</span>}
                                                                </div>
                                                            </td>
                                                            <td className="right">
                                                                {c.total_price} {state.unpaid.currency}
                                                            </td>
                                                            <td className="right">
                                                                {c.vat_price} {state.unpaid.currency}
                                                            </td>
                                                            <td className="right">
                                                                {c.gross_price} {state.unpaid.currency}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                        {trans('tables.total')}
                                                    </td>
                                                    <td className="right">
                                                        <b>{state.unpaid.totals.price} {state.unpaid.currency}</b>
                                                    </td>
                                                    <td className="right">
                                                        <b>{state.unpaid.totals.vat} {state.unpaid.currency}</b>
                                                    </td>
                                                    <td className="right">
                                                        <b>{state.unpaid.totals.gross} {state.unpaid.currency}</b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                        }
                    </>
                )}

                {activeTab === 5 && (
                    <>
                        <h3>
                            {trans('tabs.list')}
                        </h3>
                        {state.parts.loading
                            ?
                            <Skeleton height={45} count={10} />
                            :
                            state.parts.data.length === 0
                                ?
                                <div className="alert warning">{trans('messages.noResultsFound')}</div>
                                :
                                <>
                                    <div className="table-scroller">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {trans('tables.status')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.contractor')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.name')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.number')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.refNo')}
                                                    </th>
                                                    <th>
                                                        {trans('tables.address')}
                                                    </th>
                                                    <th className="right">
                                                        {trans('tables.usedOn')}
                                                    </th>
                                                    <th className="center">
                                                        {trans('tables.quantity')}
                                                    </th>
                                                    <th className="right">
                                                        {trans('tables.price')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.parts.data.map(p =>
                                                    <tr key={'p-' + p.id}>
                                                        <td>
                                                            {p.status && p.status?.translation ? p.status?.translation?.name : p.status?.name}
                                                        </td>
                                                        <td>
                                                            {p?.contractor_name}
                                                        </td>
                                                        <td>
                                                            {p?.name}
                                                        </td>
                                                        <td>
                                                            {p.number || '-'}
                                                        </td>
                                                        <td>
                                                            {p.reservation
                                                                ?
                                                                <a
                                                                    href={'/schedule/reservations/edit/' + p.reservation_id} target="_blank"
                                                                // className="btn"
                                                                // style={{ background: p.reservation.color, color: p.reservation.text_color }}
                                                                >
                                                                    {p.reservation.reference_code}
                                                                </a>
                                                                :
                                                                '-'
                                                            }
                                                        </td>
                                                        <td>
                                                            {p.reservation
                                                                ?
                                                                p.reservation.full_address
                                                                :
                                                                '-'
                                                            }
                                                        </td>
                                                        <td className="right">
                                                            {p.add_date}
                                                        </td>
                                                        <td className="center">
                                                            {p.quantity}
                                                        </td>
                                                        <td className="right">
                                                            {p.net_price_format} {p.currency?.name}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        pages={state.parts.pages}
                                        page={state.parts.page}
                                        handlePage={handlePartsPage}
                                    />

                                </>
                        }
                    </>
                )}
            </div>
        </div>
    )
}

export default Index